import { DME, DMEData } from "dmeditor";
import { nanoid } from "nanoid";
import { EntityClubInfo } from "./entity";
const definition: DME.Widget = {
  category: "bridge",
  icon: "bridge",
  name: "Krets information",
  type: "bridge-krets-information",
  events: {
    createBlock: (): DMEData.Block<EntityClubInfo> => {
      return {
        id: nanoid(),
        type: "bridge-krets-information",
        data: {},
      };
    },
    updateData: () => {},
  },
  settings: [],
};

export default definition;
